import { Grid } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ILegalPerson } from '../../../Interfaces/ILegalPerson';
import { EmailField } from '../fields/Email/EmailField';
import { BirthdateField } from './fields/Birthdate/BirthdateField';
import { BirthplaceField } from './fields/Birthplace/BirthplaceField';
import { BusinessFormField } from './fields/BusinessForm/BusinessFormField';
import { DateOfDeathField } from './fields/DateOfDeath/DateOfDeathField';
import { FirstNameField } from './fields/FirstName/FirstNameField';
import { PlaceOfDeathField } from './fields/PlaceOfDeath/PlaceOfDeathField';
import { SalesTaxNumberField } from './fields/SalesTaxNumber/SalesTaxNumberField';
import { TaxNumberField } from './fields/TaxNumber/TaxNumberField';

export const LegalPersonForm = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='de'>
      <Grid item xs={3}>
        <BusinessFormField<ILegalPerson> name='idBusinessForm' />
      </Grid>

      <Grid item xs={3}>
        <FirstNameField<ILegalPerson> name='FirstName' />
      </Grid>

      <Grid item xs={3}>
        <BirthdateField<ILegalPerson> name='Birthdate' />
      </Grid>

      <Grid item xs={3}>
        <BirthplaceField<ILegalPerson> name='Birthplace' />
      </Grid>

      <Grid item xs={3}>
        <TaxNumberField<ILegalPerson> name='TaxNumber' />
      </Grid>

      <Grid item xs={3}>
        <SalesTaxNumberField<ILegalPerson> name='SalesTaxNumber' />
      </Grid>

      <Grid item xs={3}>
        <EmailField<ILegalPerson> name='Email' />
      </Grid>

      <Grid item xs={3}>
        <DateOfDeathField<ILegalPerson> name='DateOfDeath' />
      </Grid>
      <Grid item xs={3}>
        <PlaceOfDeathField<ILegalPerson> name='PlaceOfDeath' />
      </Grid>
    </LocalizationProvider>
  );
};
